import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { newPorcentajeIvaServicesSchema } from '@/shared';
import { useCreatePorcentajeIvaServicios, useUpdatePorcentajeIvaServicios } from '@/shared/actions/erp';
import {

  CustomNumberTextField,
  CustomTextField,
  SingleFormBoxScene,
  SwitchComponenteForm,
} from '@/shared/components/ui';
import { PORCENTAJEIVASERVICIOS } from '@/shared/interfaces';
import { Grid, InputAdornment } from '@mui/material';

const returnUrlPRIVA = '/parametrizacion/porcentajes-ret-iva-servicios';

export interface SavePorcentajeIvaServiciosInterface {
  titlePage: string;
  editPorcentajeIvaServicios?: PORCENTAJEIVASERVICIOS;
}

type SaveFormData = {
  codigo: string;
  porcentaje: number;
  estado: boolean;
};

const SavePorcentajeIvaRet: React.FC<SavePorcentajeIvaServiciosInterface> = ({ titlePage, editPorcentajeIvaServicios }) => {
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  ///* mutations
  const createPorcentajeIvaRetMutation = useCreatePorcentajeIvaServicios({ navigate, returnUrl: returnUrlPRIVA });
  const updatePorcentajeIvaRetMutation = useUpdatePorcentajeIvaServicios({ navigate, returnUrl: returnUrlPRIVA });

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newPorcentajeIvaServicesSchema),
  });
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* upd
    if (editPorcentajeIvaServicios?.id_porcentaje_ret_iva_servicios) {
      return updatePorcentajeIvaRetMutation.mutate({
        id: editPorcentajeIvaServicios.id_porcentaje_ret_iva_servicios,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createPorcentajeIvaRetMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editPorcentajeIvaServicios) {
      setShrink(true);
      reset({
        ...editPorcentajeIvaServicios,
      } as any);
    }
  }, [editPorcentajeIvaServicios]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlPRIVA);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        label="Codigo"
        name='codigo'
        control={form.control}
        error={errors.codigo}
        helperText={errors.codigo?.message}
        shrink={shrink}
      />

      <CustomNumberTextField
        label="Porcentaje"
        name="porcentaje"
        ///register={register('porcentaje')}
        error={errors.porcentaje}
        helperText={errors.porcentaje?.message}
        shrink={shrink}
        min={0}
        max={100}
        control={form.control}
        defaultValue={form.getValues().porcentaje || ''}
        startAdornment={<InputAdornment position="start">%</InputAdornment>}
      />

      <Grid container item >
        <SwitchComponenteForm
          control={control}
          defaultValue={form.getValues().estado || true}
          label={"Estado"}
          name="estado"
        />
      </Grid>
    </SingleFormBoxScene>
  );
};

export default SavePorcentajeIvaRet;
